<app-storage-warning></app-storage-warning>

<main>
  <mat-grid-list cols="3" rowHeight="250px">
    @for (workOrder of getWorkOrders(); track workOrder) {
      <mat-grid-tile>
        <app-work-order-card
          [workOrder]="workOrder"
          [isOnline]="false"
          [isOfflineFallback]="true"
          (downloadRemoved)="removeWorkOrder($event)"
          (toggleFavourite)="toggleFavourite()"
        ></app-work-order-card>
      </mat-grid-tile>
    }
  </mat-grid-list>
</main>
